import useClusterConfig from "hooks/useClusterConfig";
const INVESTIGATION_EVENTS_STREAM_CONFIG = "org.graylog.plugins.securityapp.migrations.InvestigationEventsStreamConfig";
const useInvestigationsEventsConfig = () => useClusterConfig(INVESTIGATION_EVENTS_STREAM_CONFIG);
export default useInvestigationsEventsConfig;
